export const ADD_PRODUCT = 'ADD_PRODUCT'
export const SET_PRODUCT_VALUE = 'SET_PRODUCT_VALUE'
export const RELOAD_INVENTORY = 'RELOAD_INVENTORY'
